import axiosInstance from "../../apiAxios/axiosInstance";

export const getVendorRequirementPermission = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/vendor-requirement-permission-view",
    payload
  );
  return response.data;
};
export const getAllPermission = async () => {
  const response = await axiosInstance.get(
    "/admin/all-permissions-list");
  return response.data;
};

export const updatePermission = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/vendor-requirement-permission-update",
    payload
  );
  return response.data;
};
